import React from 'react'
import Header from '../../component/header/Header'
import QuizQuestions from '../../component/quizquestions/QuizQuestions'
import Footer from '../../component/footer/Footer'

const quiz = () => {
  return (
    <div>
      <Header/>
      <QuizQuestions/>
      <Footer/>
    </div>
  )
}

export default quiz
